// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./slide-image-2.jpg");
var dir = previousRequest.replace("slide-image-2.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "slide-image-2.jpg",
	name: "slide-image-2",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/slide-image-2.jpg
// module id = 40
// module chunks = 4